module.exports = __webpack_public_path__ + "static/img/banner1.2bea3192.jpg";